/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import {Icon} from 'semantic-ui-react'
import * as styles from './styles/header.module.css'

const ShoppingCartIcon = ({cartCount, size}) => {
	const showCartCount = () => {
		if (!cartCount) {
			return `(0)`
		}
		if (cartCount > 9) {
			return (
				<span>
					9<sup>+</sup>
				</span>
			)
		}
		return `(${cartCount})`
	}
	return (
		<div className={styles.text}>
			<Icon name="cart" size={size}/>
			{showCartCount()}
		</div>
	)
}

export default ShoppingCartIcon
